import { GridColTypeDef } from '@material-ui/data-grid';
import { formatStringDate } from '@domain/utils/format.utils';

export const formatColWithDate: GridColTypeDef = {
  type: 'string',
  width: 140,
  valueFormatter: ({ value }) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return formatStringDate(value);
  },
};

export function valueGridMoneyFormatter(params: any): any {
  return params.value || '';
}
